export var E2E_TEST_TOKEN_LOCAL_STORAGE_KEY = "E2E_TEST_TOKEN";
export var E2E_TEST_TOKEN_HEADER = "X-E2E-TEST-TOKEN";
export var E2E_TEST_TOKEN_VAR = "E2E_TEST_TOKEN_VAR";
